import "../styles/vertical-banner.css";

const VerticalBannerSection = () => {
  return (
    <section className="vertical-banner-section">
      <div className="vertical-banner-section__overlay" />

      <div className="vertical-banner-section__content vertical-banner--info">
        <img
          src="/images/10-ai.png"
          alt="10 kỹ năng AI"
          className="vertical-banner__image"
        />

        <img
          src="/images/bo-cong-cu.png"
          alt="Bộ công cụ AI"
          className="vertical-banner__image"
        />
      </div>
    </section>
  );
};

export default VerticalBannerSection;
